import React from 'react';
import { Menu, Phone } from 'lucide-react';
import { Button } from './Button';
import { Sheet, SheetContent, SheetTrigger } from './Sheet';
import { Logo } from './Logo';
const NAV_LINKS = [{
  name: 'Services',
  href: '#services'
}, {
  name: 'Gallery',
  href: '#gallery'
}, {
  name: 'Reviews',
  href: '#reviews'
}, {
  name: 'Service Area',
  href: '#service-area'
}, {
  name: 'Contact',
  href: '#contact'
}];
export function Header() {
  return <header className="sticky top-0 z-50 w-full bg-dark/95 backdrop-blur supports-[backdrop-filter]:bg-dark/80 border-b border-accent/20 h-[60px] md:h-[80px] flex items-center" data-id="element-98">
      <div className="container mx-auto px-4 flex items-center justify-between h-full" data-id="element-99">
        <a href="#" className="flex items-center gap-2 shrink-0" data-id="element-100">
          <Logo data-id="element-101" />
        </a>

        <nav className="hidden lg:flex items-center gap-8" data-id="element-102">
          {NAV_LINKS.map(link => <a key={link.name} href={link.href} className="text-sm font-bold text-slate-300 hover:text-accent-light transition-colors uppercase tracking-wider" data-id="element-103">
              {link.name}
            </a>)}
        </nav>

        <div className="hidden lg:flex items-center gap-4" data-id="element-104">
          <a href="tel:208-716-7525" className="flex items-center gap-2 text-slate-300 hover:text-white transition-colors font-bold" data-id="element-105">
            <Phone className="h-4 w-4 text-accent" data-id="element-106" />
            208-716-7525
          </a>
          <Button className="bg-accent hover:bg-accent-light text-white font-bold uppercase tracking-wider" data-id="element-107">
            Get a Free Quote
          </Button>
        </div>

        <div className="lg:hidden flex items-center gap-4" data-id="element-108">
          <a href="tel:208-716-7525" className="text-accent p-2" data-id="element-109">
            <Phone className="h-5 w-5" data-id="element-110" />
          </a>
          <Sheet data-id="element-111">
            <SheetTrigger asChild data-id="element-112">
              <Button variant="ghost" size="icon" className="text-slate-300 hover:text-accent hover:bg-transparent" data-id="element-113">
                <Menu className="h-6 w-6" data-id="element-114" />
                <span className="sr-only" data-id="element-115">Toggle menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-dark border-l-accent/20 pt-16" data-id="element-116">
              <nav className="flex flex-col gap-6" data-id="element-117">
                {NAV_LINKS.map(link => <a key={link.name} href={link.href} className="text-lg font-bold text-slate-300 hover:text-accent-light transition-colors uppercase tracking-wider" data-id="element-118">
                    {link.name}
                  </a>)}
                <div className="h-px bg-accent/20 my-4" data-id="element-119" />
                <a href="tel:208-716-7525" className="flex items-center gap-2 text-white font-bold text-lg" data-id="element-120">
                  <Phone className="h-5 w-5 text-accent" data-id="element-121" />
                  208-716-7525
                </a>
                <Button className="bg-accent hover:bg-accent-light text-white font-bold uppercase tracking-wider w-full h-12 mt-4" data-id="element-122">
                  Get a Free Quote
                </Button>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>;
}